module.exports = __webpack_public_path__ + "platform-web/static/media/product.53493313.svg";